<template>
  <div class="pagoda-remark-box">
    <el-popover
      :placement="placement"
      :title="title || getDefaultText()"
      width="250"
      trigger="click"
      v-if="editable"
      v-model="visible"
      popper-class="pagoda-remark-box-popper"
      @hide="cancel">
      <!--<i class="el-icon-circle-close close-remark text-danger" @click="visible = false"></i>-->
      <!-- <el-input
        type="textarea"
        :rows="4"
        :placeholder="placeholder || getDefaultText()"
        resize="none"
        v-model="remark">
      </el-input> -->
      <!-- 用自己封装的textarea组件 -->
      <textarea-cell v-model="remark" :maxlength="maxlength" :rows="4" :placeholder="placeholder || getDefaultText()" resize="none"></textarea-cell>
      <div class="pagoda-button-group">
        <el-button type="primary" @click="confirm">确定</el-button>
        <el-button type="text" @click="visible = false">取消</el-button>
      </div>
      <div slot="reference">
        <el-tooltip :content="value" :placement="placement" effect="light">
          <div class="remark-content">{{value}}</div>
        </el-tooltip>
        <div class="remark-button pointer">
          <i class="el-icon-circle-plus vertical-middle"></i>
          <el-button style="margin-left: -5px;padding: 0;" type="text" size="mini">{{text || getDefaultText()}}</el-button>
        </div>
      </div>
    </el-popover>
    <el-tooltip v-else :content="value" :placement="placement" effect="light">
      <div class="remark-content">{{value}}</div>
    </el-tooltip>
  </div>
</template>

<script>
import textareaCell from './textarea-cell'
export default {
  name: 'RemarkCell',
  components: {
    textareaCell
  },
  data () {
    return {
      visible: false,
      remark: this.value
    }
  },
  props: {
    // 浮窗方向
    placement: {
      type: String,
      default: 'left'
    },
    value: String,
    editable: {
      type: Boolean,
      default: true
    },
    title: String,
    placeholder: String,
    text: String,
    maxlength: null
  },
  created () {
  },
  mounted () {
  },
  watch: {
    value (n) {
      this.remark = n
    }
  },
  methods: {
    confirm () {
      this.$emit('input', this.remark)
      this.$emit('confirm', this.remark)
      this.visible = false
    },
    cancel () {
      this.remark = this.value
    },
    getDefaultText () {
      return this.value ? '修改备注' : '添加备注'
    }
  },
  computed: {
  }
}
</script>
